import clsx from 'clsx'
import {ReactNode, useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'

type ModularAsideMenuItemWithSubProps = {
  activeRoutes: string[]
  children: ReactNode
  icon?: string
  title: string
  to: string
}

const ModularAsideMenuItemWithSub = ({
  activeRoutes,
  children,
  icon,
  title,
  to,
}: ModularAsideMenuItemWithSubProps) => {
  const {pathname} = useLocation()
  const isActive = [to, ...activeRoutes].some((route) => checkIsActive(pathname, route))
  const [isExpanded, setIsExpanded] = useState(isActive)

  useEffect(() => {
    if (isActive) {
      setIsExpanded(true)
    }
  }, [isActive])

  return (
    <div
      className={clsx('menu-item menu-accordion', {
        here: isActive,
        show: isExpanded,
      })}
    >
      <button
        type='button'
        className='menu-link'
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((current) => !current)}
      >
        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow' aria-hidden='true'></span>
      </button>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {ModularAsideMenuItemWithSub}
